import { render } from "./ConfirmVer.vue?vue&type=template&id=5a6b742a"
import script from "./ConfirmVer.vue?vue&type=script&lang=js"
export * from "./ConfirmVer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__